import http from '../../../../libs/http'
export default ({ id }) => http.delete(`${process.env.VUE_APP_MICROSERVICE_API_SHOPS}/requests/detail/${id}`)
